var exports = {
  "C": "xfd349460--350e26--onboarding-anchor",
  "Y": "xfd349460--350e26--onboarding-content",
};

module.exports = exports;
